import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Tile from "./Tile";
import {
  restartGame,
  putTileToStock,
  drawTileToAI,
  drawTileToUser,
  drawFirstTileToPlayline,
  userMissesMove,
  aiMakesMove,
} from "../redux/dominoSlice";
import {
  StockContainer,
  Button,
  Nav,
  IconRestart,
  IconQuestion,
  Container,
  Modal,
  ModalContent,
  Close,
  Message,
  BlockInfo,
  ButtonBlock,
  BlockContent,
} from "./styled";
import { dispatchConsequently } from "../util/tileOperations";
import restart from "./img/gnome-session-reboot-svgrepo-com 1.svg";
import question from "./img/questionmark_83826 1.svg";
import { localizations, getLanguage } from "./localization";

const Stock = () => {
  const dispatch = useDispatch();
  const { playline } = useSelector((state) => state.domino);
  const [isVisible, setIsVisible] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isModal, setIsModal] = useState(false);
  const tiles = useSelector((state) => state.domino.stock);
  const { winner } = useSelector((state) => state.domino);
  const { stock } = useSelector((state) => state.domino);

  const handleRestart = () => {
    window.ysdk.features.GameplayAPI.stop();
    window.ysdk.adv.showFullscreenAdv({
      callbacks: {
        onClose: function (wasShown) {
          window.ysdk.features.GameplayAPI.start();
          dispatch(restartGame());
        },
        onError: function (error) {},
      },
    });
  };

  const handleDrawTile = () => {
    dispatch(drawTileToUser());
  };

  const resetGame = async () => {
    const interval = 0.3;
    dispatch(restartGame());
    await dispatchConsequently(dispatch, {
      action: putTileToStock,
      steps: 28,
      interval: 0.05,
    });
    await dispatchConsequently(dispatch, {
      action: drawTileToAI,
      steps: 6,
      interval,
    });
    await dispatchConsequently(dispatch, {
      action: drawTileToUser,
      steps: 6,
      interval,
    });
    dispatch(drawFirstTileToPlayline());
  };

  const handleMissMove = () => {
    dispatch(userMissesMove());
    dispatch(aiMakesMove());
    setTimeout(() => {
      dispatch(drawTileToAI());
    }, 300);
  };

  useEffect(() => {
    if (!playline.length) {
      setIsDisabled(true);
    } else if (playline.length === 1) {
      setIsDisabled(false);
    }
  }, [playline]);

  useEffect(() => {
    if (winner === null) {
      window.ysdk.features.GameplayAPI.stop();
      window.ysdk.adv.showFullscreenAdv({
        callbacks: {
          onClose: function (wasShown) {
            window.ysdk.features.GameplayAPI.start();
            resetGame();
          },
          onError: function (error) {},
        },
      });
    }
  }, [winner]);
  return (
    <div>
      {isModal && (
        <Modal>
          <ModalContent>
            <BlockInfo>{localizations.hint[getLanguage()]}</BlockInfo>
            <Message>{localizations.textHint[getLanguage()]}</Message>
            <ButtonBlock>
              <Button onClick={() => setIsModal((prev) => !prev)}>
                {localizations.close[getLanguage()]}
              </Button>
            </ButtonBlock>
          </ModalContent>
        </Modal>
      )}
      <Nav>
        <Container>
          <Button
            disabled={isDisabled}
            onClick={() => setIsVisible((prev) => !prev)}
          >
            {localizations.warehouse[getLanguage()]}
          </Button>
          <Button
            disabled={isDisabled}
            onClick={
              winner
                ? handleRestart
                : stock?.length > 0
                ? handleDrawTile
                : handleMissMove
            }
          >
            {winner
              ? `${localizations.startOver[getLanguage()]}`
              : stock?.length > 0
              ? `${localizations.getIt[getLanguage()]}`
              : `${localizations.skipMove[getLanguage()]}`}
          </Button>
        </Container>
        <Container>
          <Button
            disabled={isDisabled}
            onClick={() => {
              if (winner === null) {
                window.ysdk.features.GameplayAPI.stop();
                return window.ysdk.adv.showFullscreenAdv({
                  callbacks: {
                    onClose: function (wasShown) {
                      window.ysdk.features.GameplayAPI.start();
                      resetGame();
                    },
                    onError: function (error) {},
                  },
                });
              }
              return handleRestart();
            }}
          >
            <IconRestart src={restart} />
          </Button>
          <Button
            disabled={isDisabled}
            onClick={() => setIsModal((prev) => !prev)}
          >
            <IconQuestion src={question} />
          </Button>
        </Container>
      </Nav>
      {!isVisible && (
        <Modal>
          <ModalContent>
            <BlockInfo>{localizations.gameStock[getLanguage()]}</BlockInfo>
            <BlockContent>
              {tiles?.length > 0 ? (
                <StockContainer>
                  {tiles?.map((tile) => (
                    <Tile
                      key={tile.id}
                      tile={tile}
                      size="sm"
                      color="textSecondary"
                      duration={0.4}
                      variant="dimmed"
                    />
                  ))}
                </StockContainer>
              ) : (
                <Message>{localizations.emptyStock[getLanguage()]}</Message>
              )}
            </BlockContent>
            <ButtonBlock>
              <Button onClick={() => setIsVisible((prev) => !prev)}>
                {localizations.close[getLanguage()]}
              </Button>
            </ButtonBlock>
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default Stock;
